import { GET_QRCODE, GET_QRCODE_ERROR } from '../actions/types';

const initialState = {
  data: {},
  error: null,
  loading: true,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_QRCODE:
      return {
        ...state,
        data: { qrcode: payload?.qrcode, msg: payload?.msg },
        error: null,
        loading: false,
      };
    case GET_QRCODE_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
